import type { RegexPattern } from '../types';

/**
 * @group Constants
 * @summary <blockquote>Regex patterns for input validation.</blockquote>
 * 
 * Patterns used to validate string formats (naming conventions, identifiers, etc.)
 */
export const VALIDATION_PATTERNS = {
  /**
   * Validates kebab-case strings (lowercase alphanumeric with hyphens)
   * Example: "user-service", "api-key"
   */
  KEBAB_CASE: {
    regex: /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
    description: 'Validates kebab-case strings (lowercase alphanumeric with hyphens)',
    examples: ['user-service', 'api-key', 'http-connection'],
    counterExamples: ['UserService', 'API_KEY', 'user_service', '-user', 'user-'],
  } as RegexPattern,

  /**
   * Validates PascalCase strings (starts with uppercase, alphanumeric)
   * Example: "UserService", "APIKey"
   */
  PASCAL_CASE: {
    regex: /^[A-Z][a-zA-Z0-9]*$/,
    description: 'Validates PascalCase strings (starts with uppercase, alphanumeric)',
    examples: ['UserService', 'APIKey', 'HTTPConnection'],
    counterExamples: ['userService', 'API_KEY', 'user-service', 'User_Service'],
  } as RegexPattern,

  /**
   * Validates camelCase strings (starts with lowercase, alphanumeric)
   * Example: "userName", "apiKey"
   */
  CAMEL_CASE: {
    regex: /^[a-z][a-zA-Z0-9]*$/,
    description: 'Validates camelCase strings (starts with lowercase, alphanumeric)',
    examples: ['userName', 'apiKey', 'httpConnection'],
    counterExamples: ['UserName', 'API_KEY', 'user-name', 'user_name'],
  } as RegexPattern,

  /**
   * Validates snake_case strings (lowercase alphanumeric with underscores)
   * Example: "user_name", "api_key"
   */
  SNAKE_CASE: {
    regex: /^[a-z0-9]+(?:_[a-z0-9]+)*$/,
    description: 'Validates snake_case strings (lowercase alphanumeric with underscores)',
    examples: ['user_name', 'api_key', 'http_connection'],
    counterExamples: ['userName', 'API_KEY', 'user-name', '_user', 'user_'],
  } as RegexPattern,
} as const;
